import actions from '../../lib/api/actions';

export async function fetchLocations({ commit }, payload) {
  const response = await actions.fetchLocations(payload);

  if (response.status === 200) {
    commit('setLocations', response.data);
  }
}

export async function fetchDeliveryMethods({ commit }) {
  const response = await actions.fetchDeliveryMethods();

  if (response.status === 200) {
    commit('setDeliveryMethods', response.data);
  }
}

export async function fetchPaymentMethods({ commit }) {
  const response = await actions.fetchPaymentMethod();

  if (response.status === 200) {
    commit('setPaymentMethods', response.data);
  }
}
